// Default class names for loader container
export const SELECTOR = '[data-image-loader="true"]';

class ProgressiveImageLoader {
  /**
   * Initializer
   *
   * @param {Element} elementRef - HTML node, to progressively load a background image.
   * */
  constructor(elementRef) {
    // Initialise attributes
    this.elementRef = elementRef;
    this.elementRef.classList.add('progressive-image');
    this.image = new Image();

    // Bind functions
    this.onLoad = this.onLoad.bind(this);

    this._setup();
  }

  /**
   * Load the high res image.
   * */
  load() {
    this.image.src = this.elementRef.dataset['imagePath'];
  }

  // Event Handlers

  /**
   * Event callback to be triggered after the high res image has been loaded.
   * */
  onLoad() {
    this.overlay.style.backgroundImage = `url(${this.image.src})`;
    this.overlay.style.opacity = 1;
  }

  // private

  /**
   * Set-up the ProgressiveImageLoader.
   *  1) Append the overlay element to load the high res image.
   * */
  _setup() {
    this.overlay = this._createOverlay();
    this._addEventListeners();
  }

  /**
   * Creates the overlay.
   *
   * @return {Element} - HTML node for the overlay.
   * */
  _createOverlay() {
    let overlay = document.createElement('div');
    overlay.setAttribute('class', 'progressive-image--overlay');
    this.elementRef.appendChild(overlay);

    return overlay;
  }

  /**
   * Adds all the required event listeners.
   * */
  _addEventListeners() {
    this.image.onload = this.onLoad;
  }
}

export default ProgressiveImageLoader;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/progressiveImageLoader/index.js